import React from "react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import BrandLogo from "../components/BrandLogo";

export default function ThankYou() {
  const navigate = useNavigate();
  return (
    <div className="dark-site min-h-screen bg-soft flex flex-col items-center justify-center px-6">
      <div className="max-w-xl text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-paul-yellow flex items-center justify-center">
            <CheckCircle2 className="w-12 h-12 text-white" strokeWidth={2} />
          </div>
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold text-navy">
          You&apos;re in.
        </h1>
        <p className="mt-4 text-lg text-gray-600 leading-relaxed">
          Thanks for sharing all that. I&apos;ll personally read through your
          answers and get back to you within 24-48 hours. Check your inbox for
          a quick confirmation.
        </p>
        <div className="mt-10">
          <Button
            onClick={() => navigate("/")}
            className="bg-paul-yellow hover:bg-paul-yellow text-navy font-bold px-10 py-6"
            style={{ color: "#0b1535" }}
          >
            Back to Home
          </Button>
        </div>
        <div className="mt-12 flex justify-center">
          <BrandLogo variant="yellow" className="h-12 opacity-60" />
        </div>
      </div>
    </div>
  );
}
